import styled, { css } from 'styled-components';

export const MenuIconWrapper = styled.div`
  width: 48px;
  height: 48px;
  background-color: ${({ theme }) => theme.colors.background.superLightGrey};
  border-radius: ${({ theme }) => theme.borderRadius.full};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  > svg {
    display: block;
  }
`;

export const MenuItemContent = styled.div`
  padding: ${({ theme }) => theme.spacers.XL} 0;
  padding-right: ${({ theme }) => theme.spacers.S};
  display: flex;
  align-items: center;
  flex-grow: 1;

  > svg {
    flex-shrink: 0;
    display: block;
  }
`;

export const MenuItemDescription = styled.p`
  ${({ theme }) => theme.typography.RegularParagraph};
  color: ${({ theme }) => theme.colors.text.darkGrey};
  text-wrap: pretty;
  font-variant-numeric: tabular-nums;
`;

export const MenuItemText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacers.S};
  flex-grow: 1;
`;

export const MenuItemTitle = styled.p`
  ${({ theme }) => theme.typography.RegularParagraphBold};
`;

export const MenuItemWrapper = styled.div<{
  $disabled: boolean;
}>`
  width: 100%;
  color: ${({ theme }) => theme.colors.text.darkerGrey};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacers['2M']};
  cursor: pointer;

  ${({ $disabled, theme }) => {
    if (!$disabled) return;

    return css`
      color: ${theme.colors.text.baseGrey};
      cursor: not-allowed;

      ${MenuItemDescription} {
        color: ${theme.colors.text.baseGrey};
      }
    `;
  }}

  &:not(:last-child) {
    ${MenuItemContent} {
      border-bottom: 2px solid ${({ theme }) => theme.colors.stroke.lighterGrey};
    }
  }
`;
